export const toastContent = {
    success: 'Success',
    error: 'Error',
    info: 'Information',
    notification: 'Notification'
}
